import React from 'react';

import TranslationUtils from 'Utils/TranslationUtils';

import { Helmet } from 'react-helmet';
import styles from './YellowPage.module.less';
import PiplLogo from '../../../Assets/pipl.png';

function YellowPage() {
  return (
    <div className={styles.container}>
      <Helmet>
        <title>{gettext('Pending Vetting')}</title>
      </Helmet>
      <a href="https://pipl.com">
        <img src={PiplLogo} alt="" width="80" height="49" />
      </a>
      <div className={styles.content}>
        <span test-id="page-title" className={styles.title}>
          {TranslationUtils.getText('YELLOW_PAGE_TITLE')}
        </span>
        <div>
          <span className={styles.body}>{TranslationUtils.getText('YELLOW_PAGE_PART_1')}</span>
          <span className={styles.body}>{TranslationUtils.getText('YELLOW_PAGE_PART_2')}</span>
        </div>
      </div>

      <div className={styles.footer}>
        <div>
          <a href="https://pipl.com" className={styles.footerLink}>
            <span>{TranslationUtils.getText('YELLOW_PAGE_LINK')}</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default YellowPage;
